import { isNil } from "lodash";

/** The dashboard's copy. */

/**
 * Why nothing on the screen can be edited, said in terms of the thing that has to happen next.
 *
 * A language keeps no draft between publishes — it is deleted on publish — so most languages sit like
 * this most of the time. That makes it a normal state to explain, not an error to warn about.
 */
export const NO_DRAFT_NOTICE =
  "This language has no working copy, so its prompts are read-only. Create Preview in Language Management to start editing.";

/**
 * A status tab's label, with the published copy's version number after it.
 *
 * 🔴 A LABEL, NOT A CHOICE. It is the flow's version rather than the content's, and no endpoint serves
 * an arbitrary version of a prompt — so it says which version is being read and offers nothing to click.
 */
export const versionTabLabel = (statusLabel: string, version?: number) =>
  isNil(version) ? statusLabel : `${statusLabel} (V${version})`;
